import { defineStore } from 'pinia'

import { usePreweddingStore } from './prewedding'
import { useSettingControlStore } from './settingControl'
import { useTemplateStore } from './template'
import { useWishStore } from './wish'
import { useSlideModeA } from '~/composables/slide/useModeA'
import { useSlideModeB } from '~/composables/slide/useModeB'
import { useSlideModeACustom } from '~/composables/slide/useModeACustom'
import { useSlideModePreview } from '~/composables/slide/useModePreview'

export const useSlideStore = defineStore({
  id: 'slide',
  state: () => {
    return {
      tmpMode: '',
      //
      stage: null as any,
      isRender: true,
      view: 'prewedding', // prewedding | wish 
      playMode: '', // mix, wish, mix-count
      index: -1,  // init start with -1
      limit: 4,  // limit play instace per set
      second: 0,
      percent: 0,
      wishInstance: {} as any,
      showNewWishIcon : false,
      isPlayingNewWish: false,
      preweddingInstance: null as any,

      //iconDisplay: 'prewedding', // prewedding, wish, new_wish  

      previousView: {
        view: null,
        index: null,
        active: false
      }, // prewedding, wish

      allInstancesPlayed: 0,
      preweddingInstancesPlayed: 0,
      wishInstancesPlayed: 0,

      settimeOutInstance: null,
      setIntervalPercent: null,

      timerMs: 0,
      INTERVAL: 1000,

      watchIndexId: null,
      transitionWish: true,
      transitionOpacity: 1,

      myWorker: undefined,


      slideInstance: null as any,
      showIndexAndLimit: true,

      // for update played
      allowUpdatePlayed: false
    }
  },
  actions: {

    initWebWorkerMessage() {
      const self = this;

      if(!self.myWorker || self.myWorker === 'undefined') {
        self.myWorker = new Worker('/js/worker.js');
      }

      // Receive messages from the worker
      self.myWorker.onmessage = function (e) {
        const message = e.data
        console.log(message);
        self.main()
      }
    },

    main() {
      this.setupModeInstance()
      this.play()
    },

    setupModeInstance() { 
      const settingControl = useSettingControlStore()

      // ถ้าดเคย setup แล้ว -> ไม่เรียกซ้ำ
      if(this.slideInstance) {
        return 
      }

      switch (this.playMode) {
        case 'mix':
          if(!settingControl.slideCustom?.active === true) {
            console.log('playing A mode')
            this.slideInstance = useSlideModeA()
            this.allowUpdatePlayed = true
          } else if(settingControl.slideCustom?.active === true) {
            console.log('playing A(custom) mode')
            this.slideInstance = useSlideModeACustom()
            this.allowUpdatePlayed = false
          }
          break;

        case 'wish':
          console.log('playing B mode')
          this.slideInstance = useSlideModeB()
          this.allowUpdatePlayed = true
          break;

        case 'preview': // custom = true เอาไวว้ใช้เล่นตอนออกบูธ
          console.log('playing preview mode')
          this.slideInstance = useSlideModePreview()
          this.allowUpdatePlayed = false
          break;
      
        default:
          break;
      }
    },

    play() {      
      const result = this.slideInstance.main()

      switch (result.type) {
        case 'wish':
          this.view = 'wish'
          this.renderWish(result.data)
          break;

        case 'prewedding':
          this.view = 'prewedding'
          this.renderPrewedding(result.data)
          break;
      
        default:
          break;
      }

      this.startTimer()
      this.listeningWorker()
      this.allInstancesPlayed++
    },

    async renderWish(wishData) {
      const wishStore = useWishStore()
      const templateStore = useTemplateStore()

      if (!wishData) {
        this.next()
        return
      }

      console.log("wishInstancesPlayed", this.wishInstancesPlayed, wishData)
      this.wishInstance = wishData
      
      if (this.stage && this.stage.destroy) {
        this.stage.width(0)
        this.stage.height(0)
        console.log("destroy stage", this.wishInstancesPlayed)
        this.stage.batchDraw()
        this.stage.destroy()
        this.stage = null
        this.transitionWish = false
        this.transitionOpacity = 0
      }
  
      try {
        templateStore.docId = wishData?.docId
        const renderStage = await templateStore.render(wishData)
        templateStore.docId = wishData?.docId
  
        // -- transition  animation --
        this.transitionWish = true
        this.transitionOpacity = 1
        // ---------------------------
  
        this.stage = renderStage
        this.wishInstancesPlayed++

        if(this.allowUpdatePlayed) {
          wishStore.updatePlayWish(wishData, true) // <== database
        }

      } catch (error) {
        console.error(error)
      }
    },

    async renderPrewedding(preweddingData) {
      const preweddingStore = usePreweddingStore()
    //  this.wishInstance = null
      this.stage && this.stage.destroy()
      this.stage = null
  
      const tmpStage = this.stage
  
  
      if (tmpStage) {
        tmpStage.destroy()
        this.stage = null
      }
  
      this.preweddingInstance = preweddingData
      this.preweddingInstancesPlayed++
  
      if (preweddingStore.queue.length == 0) {
        let previousUrl = this.preweddingInstance
        preweddingStore.shuffle(previousUrl)
      }
    },

    checkNextSlide() {
      const wishStore = useWishStore()
      if (wishStore.queue.length == 0) {
        let previousId = this.wishInstance.docId
        wishStore.shuffle(previousId)
      }

      // ------ set limit  เมื่อมีน้อยกว่า 4 -------
      if (wishStore.all.length < this.limit) {
        this.limit = wishStore.all.length
      }
      // --------------------------------------
    },

    restore_Previous_View_And_Save_If_New_Wish_Avaliable() {
      const wishStore = useWishStore()
      // restore previous view
      if (this.previousView.active) {
        this.view = this.previousView.view
        this.index = this.previousView.index
        this.previousView.active = false
      }
  
  
      // save previous view if new wish available and not yet save
      let newWishList = wishStore.getNewDocIdList()
      if (newWishList.length > 0 && !this.previousView.active) {
        this.previousView.view = this.view
        this.previousView.index = this.index
        this.previousView.active = true
      }
    },

    startTimer() { // progressbar
      // clear prevoius  
      this.setIntervalPercent = clearInterval(this.setIntervalPercent)
  
      this.percent = 0
      this.timerMs = 0
      const durationSec = this.itemTimer
  
      //percent  
  
      this.setIntervalPercent = setInterval(() => {
  
        this.timerMs = this.timerMs + this.INTERVAL
  
        this.percent = (this.timerMs / (durationSec * 1000)) * 100
        if (this.percent >= 100) {
          this.percent = 100
        }
      }, this.INTERVAL)
  
  
    },

    listeningWorker() { // timer
      // worker clear timer and run
      if (window.Worker) {
        this.myWorker && this.myWorker.postMessage({
          company: 'photowish',
          timer: this.itemTimer * 1000,
        });
        
      } else {
        this.settimeOutInstance = setTimeout(() => {
          this.main()
        }, (this.itemTimer * 1000 ) +20)
      }
    },

    rerender() {
      this.isRender = false
      setTimeout(() => {
        this.isRender = true
      }, 800)
    },

    next() {
      this.slideInstance?.next && this.slideInstance?.next()
      this.main()
    },

    // --- for mode: preview ---
    prev() {
      this.slideInstance?.prev && this.slideInstance?.prev()
      this.main()
    },

    previewTargetWish(wish: any) {
      this.slideInstance?.selectTargetWish && this.slideInstance?.selectTargetWish(wish)
      this.main()
    }
    // -------------------------



  },
  getters: {
    itemLimit(state) {
      const settingControl = useSettingControlStore()
      const timer: any = settingControl.timer
      let view = state.view
      
      return timer[view].limit
    },
    itemTimer(state) {
      const settingControl = useSettingControlStore()
      const timer: any = settingControl?.timer 
      const view = state.view
      return timer[view].timer
    },

  }
})
